// extracted by mini-css-extract-plugin
export var redoItem = "_ih-1";
export var redoTrigger = "_ih-0";